<style>
  .PersonImgUl{
    position: absolute;
    width: 20px;
    height: 25px;
    transition: all  2s ease;

  }
  .PersonImgUl:hover{
    width: 75px;
    height: 100px;
    z-index: 50;
  }
</style>

<ul>
  <li *ngFor="let item of inner_17025_Cat" class="MyMoeinListCat_Li">

    <div class="MyMoeinListCat_Div">

      <i class="fa  fa-modx" style="visibility: visible !important;" ></i>

      <span class="MyMoeinListCat_Span">{{item.title}}
        <span *ngIf="item.code">({{item.code}})</span>
      </span>

      <i class="fa fa-eye" *ngIf="item.child.length>0 && item.childVisible" style="visibility: visible !important;" (click)="Change_Visible(item)"></i>
      <i class="fa fa-eye-slash" style="visibility: visible !important;" *ngIf="item.child.length>0 && !item.childVisible" (click)="Change_Visible(item)"></i>

      <i title="بالا" class="fa fa-arrow-circle-up" (click)="OnSet_Up_Action(item)"></i>
      <i title="پایین" class="fa fa-arrow-circle-down"  (click)="OnSet_Down_Action(item)"></i>
      <i title="فرزند" class="fa fa-cut"  (click)="OnSet_Child_Action(item)"></i>
      <i title="انتقال" class="fa fa-paste"  (click)="OnSet_Cut_Action(item)"></i>

      <i title="افزودن سمت"  class="fa  fa-plus-circle MyMoeinListCat_Add" style="margin-right: 10px;" (click)="OnSet_Add_Action(item)"></i>
      <i title="پرسنل"  class="fa  fa fa-user-circle MyMoeinListCat_Add" (click)="OnSet_Person_Action(item)"></i>
  

      <i title="ویرایش" class="fa  fa-edit MyMoeinListCat_Edit" (click)="OnSet_Edit_Action(item)" style="margin-right: 10px;"></i>
      <i title="حذف" class="fa  fa-remove MyMoeinListCat_Remove" (click)="OnSet_Remove_Action(item)"></i>

    </div>

    <ul>
      <li *ngFor="let itemPerson of item.person" class="MyMoeinListCat_Li">

        <div class="MyMoeinListCat_Div">         
          <img src="{{BaserUrlImage}}{{itemPerson.img}}" class="PersonImgUl"/>
          <span style="margin-right: 30px;" class="MyMoeinListCat_Span">{{itemPerson.fullname}}</span>
          <i title="حذف" class="fa  fa-remove MyMoeinListCat_Remove" (click)="OnSet_Remove_Person_Action(itemPerson)"></i>
        </div>
      </li>
    </ul>

    <app-Chart_Co
      [hidden]="item.childVisible==false"
      (On_Add_Action)="OnSet_Add_Action($event)"
      (On_Edit_Action)="OnSet_Edit_Action($event)"
      (On_Remove_Action)="OnSet_Remove_Action($event)"
      (On_Up_Action)="OnSet_Up_Action($event)"
      (On_Down_Action)="OnSet_Down_Action($event)"
      (On_Cut_Action)="OnSet_Cut_Action($event)"
      (On_Child_Action)="OnSet_Child_Action($event)"
      (On_Person_Action)="OnSet_Person_Action($event)"
      (On_Remove_Person_Action)="OnSet_Remove_Person_Action($event)"
      [inner_17025_Cat]="item.child">

    </app-Chart_Co>

  </li>
</ul>

